import { render, staticRenderFns } from "./ItfListGrid.vue?vue&type=template&id=24312da5"
import script from "./ItfListGrid.vue?vue&type=script&lang=js"
export * from "./ItfListGrid.vue?vue&type=script&lang=js"
import style0 from "./ItfListGrid.vue?vue&type=style&index=0&id=24312da5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports